const env = process.env.VUE_APP_RUN_ENV //pro,test,dev,proxy,mock;

let baseUrl = {
  // dev: "https://devhd.nfapp.southcn.com/nfplus-hero-api",
  dev: "https://devzmyapi.nfnews.com/nfplus-hero-api",
  // test: "https://testhd.nfapp.southcn.com/nfplus-hero-api",
  test: "https://testhdapi.nfnews.com/nfplus-hero-api",
  // pro: "https://hd2.nfapp.southcn.com/nfplus-hero-api",
  pro: "https://hdapi.nfnews.com/nfplus-hero-api",
  mock: "http://localhost:3000",
  proxy: "/api/nanfang_if"
}[env]

const buryingPointUrl = {
  // dev: "https://devcaiji.nfapp.southcn.com/analytics/sendRecord",
  dev: "https://devanalyticsapi.nfnews.com/analytics/sendRecord",
  // test: "https://testcaiji.nfapp.southcn.com/analytics/sendRecord",
  test: "https://testanalyticsapi.nfnews.com/analytics/sendRecord",
  // pro: "https://caiji.nfapp.southcn.com/analytics/sendRecord"
  pro: "https://analyticsapi.nfnews.com/analytics/sendRecord"
}[env]

const specialPageArticleUrl = {
  // dev: "https://devapi.nfapp.southcn.com/nfplus-manuscript-web",
  dev: "https://devzmyapi.nfnews.com/nfplus-manuscript-web",
  // test: "https://testapi.nfapp.southcn.com/nfplus-manuscript-web",
  test: "https://testnfplusapi.nfnews.com/nfplus-manuscript-web",
  // pro: "https://api.nfapp.southcn.com/nfplus-manuscript-web"
  pro: "https://nfplusapi.nfnews.com/nfplus-manuscript-web"
}[env]

const NETWORK_ERR_MSG = "加载失败，请稍后再试"

const UPDATE_VERSION = 610

export { baseUrl, env, UPDATE_VERSION, NETWORK_ERR_MSG, buryingPointUrl, specialPageArticleUrl }
